var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marquee-box",staticStyle:{"width":"100%","height":"30px","border":"none"}},[_c('div',{staticClass:"marquee-inner",style:(_vm.scrollStyle)},[_c('span',{style:({ marginRight: '50px',color: _vm.color ? _vm.color : '#ff0000'})},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }